var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 10.4999C1.66675 7.35722 1.66675 5.78588 2.64306 4.80956C3.61937 3.83325 5.19071 3.83325 8.33341 3.83325H11.6667C14.8094 3.83325 16.3808 3.83325 17.3571 4.80956C18.3334 5.78588 18.3334 7.35722 18.3334 10.4999V12.1666C18.3334 15.3093 18.3334 16.8807 17.3571 17.8569C16.3808 18.8333 14.8094 18.8333 11.6667 18.8333H8.33341C5.19071 18.8333 3.61937 18.8333 2.64306 17.8569C1.66675 16.8807 1.66675 15.3093 1.66675 12.1666V10.4999Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 3.83325V2.58325",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 3.83325V2.58325",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 8H17.9166",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 14.6666C14.9999 15.1268 14.6268 15.4999 14.1666 15.4999C13.7063 15.4999 13.3333 15.1268 13.3333 14.6666C13.3333 14.2063 13.7063 13.8333 14.1666 13.8333C14.6268 13.8333 14.9999 14.2063 14.9999 14.6666Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 11.3333C14.9999 11.7936 14.6268 12.1667 14.1666 12.1667C13.7063 12.1667 13.3333 11.7936 13.3333 11.3333C13.3333 10.8731 13.7063 10.5 14.1666 10.5C14.6268 10.5 14.9999 10.8731 14.9999 11.3333Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 14.6666C10.8334 15.1268 10.4603 15.4999 10.0001 15.4999C9.53983 15.4999 9.16675 15.1268 9.16675 14.6666C9.16675 14.2063 9.53983 13.8333 10.0001 13.8333C10.4603 13.8333 10.8334 14.2063 10.8334 14.6666Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 11.3333C10.8334 11.7936 10.4603 12.1667 10.0001 12.1667C9.53983 12.1667 9.16675 11.7936 9.16675 11.3333C9.16675 10.8731 9.53983 10.5 10.0001 10.5C10.4603 10.5 10.8334 10.8731 10.8334 11.3333Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 14.6666C6.66667 15.1268 6.29357 15.4999 5.83333 15.4999C5.3731 15.4999 5 15.1268 5 14.6666C5 14.2063 5.3731 13.8333 5.83333 13.8333C6.29357 13.8333 6.66667 14.2063 6.66667 14.6666Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 11.3333C6.66667 11.7936 6.29357 12.1667 5.83333 12.1667C5.3731 12.1667 5 11.7936 5 11.3333C5 10.8731 5.3731 10.5 5.83333 10.5C6.29357 10.5 6.66667 10.8731 6.66667 11.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.362e2466cbd1b1bd17f797ed0e13dc17.svg";
export { ForwardRef as ReactComponent };